import { render, staticRenderFns } from "./EditBlog.vue?vue&type=template&id=2e881da9&scoped=true&"
import script from "./EditBlog.vue?vue&type=script&lang=js&"
export * from "./EditBlog.vue?vue&type=script&lang=js&"
import style0 from "./EditBlog.vue?vue&type=style&index=0&id=2e881da9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e881da9",
  null
  
)

export default component.exports